<template>
  <div class="goals-chart-preview-header">
    <div class="main-header">
      <div class="name">
        <div v-if="profile.role !=='vendedor_dealer' && !hideParent">
          <el-button
            :class="{active: showGlobal}"
            @click="toggleGlobalGoals(true)">{{ nameObjective }}</el-button>
        </div>
        <div
          v-if="slaveLoad"
          id="bread">
          <el-button
            :class="{active: !showGlobal || hideParent}"
            @click="toggleGlobalGoals(false)">
            {{ slaveLoad }}
          </el-button>
        </div>
      </div>
      <div class="filter">
        <p><strong>AÑOS</strong></p>
        <el-select
          v-model="valueYearFilter"
          @change="yearChange">
          <el-option
            v-for="(year, index) in years"
            :key="index"
            :label="year.label"
            :value="year.value"/>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
/**
*
* GoalsChartPreviewHeader Component
*
* @author Emmanuel Hernández
* @copyright 2019, Marciano Studio S.C.
*/
import moment from 'moment'

export default {
  name: 'GoalsChartPreviewHeader',
  props: {
    profile: {
      type: Object,
      default: null
    },
    hideParent: {
      type: Boolean,
      default: false
    },
    slaveLoad: {
      type: String,
      default: null
    },
    showGlobal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      valueYearFilter: moment().format('YYYY'),
      years: [
        {
          label: moment().subtract(1, 'year').format('YYYY'),
          value: moment().subtract(1, 'year').format('YYYY')
        },
        {
          label: moment().format('YYYY'),
          value: moment().format('YYYY')
        },
        {
          label: moment().add(1, 'year').format('YYYY'),
          value: moment().add(1, 'year').format('YYYY')
        }
      ]
    }
  },
  computed: {
    nameObjective () {
      switch (this.profile.role) {
        case 'gerente_dealer':
          return 'DISTRIBUIDOR'
        case 'gerente_branch':
          return 'SUCURSAL'
        case 'superadmin':
          return 'AGCO México'
        default:
          return this.profile.name
      }
    }
  },
  methods: {
    toggleGlobalGoals (val) {
      this.$emit('show-global', val)
    },
    yearChange (val) {
      this.$router.push({...this.$route, query: {year: val}})
    }
  }
}
</script>

<style lang='scss' scoped>
  .goals-chart-preview-header {
    .active {
      border-color: $--color-primary-light-7;
      background-color: $--color-primary-light-9;
      color: $--color-primary;
      outline: none;
    }
    .main-header {
      margin-bottom: 20px;
      height: 50px;
      border: 1px solid $border-primary;
      padding-left: 10px;
      background-color: #ffffff;
      border-radius: 3px;
      display: flex;
      justify-content: space-between;
      .name{
        display: flex;
        align-items: center;
        #bread{
          margin-left: 10px;
        }
      }
      .filter{
        width: 300px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .el-select{
          width: 100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/goals/goals-chart-preview-header.vue